import { useQuery } from '@tanstack/react-query';

import { useHttpClient, type HttpResponse } from '@bonusly/http-client';

import { RecognizeResponse } from '../../../../types/api';
import { ResourcePath } from './ResourcePath';
import { QueryKey, QueryOptions } from './types';

type Format = 'index';

type ListResponse = string[];
type IndexResponse<T = Format> = RecognizeResponse<T extends Format ? ListResponse : never>;

interface IndexArgs<T extends Format = Format> {
	params: {
		display_format?: T;
	};
}

export type HashtagIndexResponse<T = Format> = HttpResponse<IndexResponse<T>>;

export const useHashtags = <T extends Format = Format>(args: IndexArgs<T>, options?: QueryOptions<HashtagIndexResponse<T>>) => {
	const http = useHttpClient('v2');

	return useQuery<HashtagIndexResponse<T>>(
		[QueryKey.Hashtags, args],
		() =>
			http.get<IndexResponse<T>>(ResourcePath.Hashtags, {
				params: args.params,
			}),
		options
	);
};
